<template>
  <CBox class="formContainer" mt="12vw">
    <CText
      class="formHeading"
      textAlign="center"
      fontSize="2vw"
      fontFamily="Ubuntu"
      mt="1vw"
      >Contact Me</CText
    >
    <CInput
      id="name"
      mt="4vw"
      mx="auto"
      placeholder="Name"
      variant="filled"
      w="40vw"
    />
    <CInput
      id="email"
      mt="1vw"
      mx="auto"
      placeholder="Email"
      variant="filled"
      w="40vw"
    />
    <CTextarea
      id="message"
      mt="1vw"
      mx="auto"
      placeholder="Mesasge"
      variant="filled"
      w="40vw"
    />
    <CBox
      @click="validate"
      border="0.1vw solid #8D4E85"
      borderRadius="5px"
      class="submitButton"
      color="#8D4E85"
      fontSize="1vw"
      mt="3vw"
      mx="auto"
      p="0.5vw"
      textAlign="center"
      w="fit-content"
    >
      Submit
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CText, CInput, CTextarea } from "@chakra-ui/vue";

export default {
  name: "ContactForm",
  components: {
    CBox,
    CText,
    CInput,
    CTextarea,
  },
  mounted() {
    let smtpScript = document.createElement("script");
    smtpScript.setAttribute("src", "https://smtpjs.com/v3/smtp.js");
    document.head.appendChild(smtpScript);
  },
  methods: {
    validate() {
      const name = document.getElementById("name").value.trim();
      const email = document.getElementById("email").value.trim();
      const message = document.getElementById("message").value.trim();

      if (name === "") {
        alert("Name Can't Be Empty!");
        return;
      }
      if (email === "") {
        alert("Email Can't Be Empty!");
        return;
      }
      if (message === "") {
        alert("Message Can't Be Empty!");
        return;
      }

      document.getElementById("name").value = "";
      document.getElementById("email").value = "";
      document.getElementById("message").value = "";
      this.notifyKishan(name, email, message);
    },
    notifyKishan(name, email, message) {
      window.Email.send({
        Host: "smtp.gmail.com",
        Username: "khirasariyakishan@gmail.com",
        Password: "ifadlzlhbziosndy",
        To: "kishankhirasariya.kk@gmail.com",
        From: "khirasariyakishan@gmail.com",
        Subject: `${name} messaging you from your website.`,
        Body: `<br><br><strong>Name:</strong> ${name} <br><br> <strong>Email:</strong> ${email} <br><br> <strong>Message:</strong> ${message}`,
      }).then(() => {
        alert("Succesfully Sent!");
      });
    },
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  ::-webkit-input-placeholder {
    font-size: 2vw;
  }
  .formContainer {
    margin-top: 14vh;
  }
  .formHeading {
    font-size: 4.5vw;
  }
  .submitButton {
    font-size: 2vw;
    padding: 1vw;
    width: 12vw;
    margin-top: 6vw;
  }
  #name {
    margin: 9vw auto 1.5vw;
    width: 70vw;
    height: 7vw;
  }
  #email {
    margin: 1.5vw auto 1.5vw;
    width: 70vw;
    height: 7vw;
  }
  #message {
    margin: 1.5vw auto 1.5vw;
    width: 70vw;
    height: 7vw;
  }
}

.submitButton:hover {
  font-weight: bold;
  border-style: dotted;
  cursor: pointer;
}

@font-face {
  font-family: "Ubuntu";
  src: local("Ubuntu"),
    url(../assets/fonts/Ubuntu-Regular.ttf) format("truetype");
}
</style>
